import { Component, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-custom-icon',
  template: `
    <span class="icon-wrapper" [ngClass]="combinedClasses">
      <span [innerHTML]="svgIcon"></span>
    </span>
  `,
  styleUrls: ['./custom-icon.component.scss'],
})
export class CustomIconComponent {
  @Input() classes: string = '';
  public svgIcon: string | SafeHtml = '';
  private iconName?: string;

  constructor(
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  get combinedClasses(): string[] {
    return this.classes.split(' ').filter(cls => cls.trim() !== '');
  }

  get name(): string | undefined {
    return this.iconName;
  }

  @Input() set name(value: string) {
    this.iconName = value;
    if (!value) {
      this.svgIcon = '';
      return;
    }
    this.setSvg();
  }

  setSvg() {
    this.httpClient.get(`assets/icons/${this.name ?? ''}.svg`, { responseType: 'text' }).subscribe(
      (value: string) => {
        this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(value);
      },
      error => {
        console.error(error);
        this.svgIcon = '';
      }
    );
  }
}
